var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 672,
    height: 529,
    viewBox: "0 0 672 529",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M382.59 192.494L775 343.893L724.5 481.393C664.391 459.789 421.268 356.645 332.929 316.981C321.315 324.035 297.249 336.506 264.436 338.223C238.866 339.524 218.51 333.825 206.492 329.403L165.184 187.484C147.71 180.281 50.4477 139.292 56.4323 106.432C57.3752 101.267 60.5524 97.9711 62.3417 96.1705C95.2218 62.7708 221.029 114.727 241.556 123.381C262.564 96.2811 296.098 83.5367 325.804 91.2429C364.796 101.35 392.328 145.439 382.59 192.494Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M303.363 158.17C303.719 187.041 289.155 208.377 272.147 211.324C257.493 213.86 245.219 202.025 243.611 200.453C227.405 184.35 226.341 153.519 241.483 123.381",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M303.363 158.17C303.719 187.041 289.155 208.377 272.147 211.324C257.493 213.86 245.219 202.025 243.611 200.453C227.405 184.35 226.341 153.519 241.483 123.381",
    stroke: "#1E1E1E",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M269.781 258.021C262.737 275.681 227.639 278.274 191.388 263.812C155.137 249.351 131.46 223.312 138.505 205.653C145.55 187.993 180.648 185.4 216.899 199.861C253.15 214.323 276.826 240.362 269.781 258.021Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M244.289 322.007C237.245 339.667 207.668 344.462 178.228 332.718C148.788 320.974 130.633 297.137 137.677 279.478C144.722 261.818 174.299 257.023 203.739 268.767C233.179 280.511 251.334 304.348 244.289 322.007Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.f8d6129d04fa734c5e9ac77396470c96.svg";
export { ForwardRef as ReactComponent };